export default "__VITE_ASSET__CCY9KDiT__"